/** Read an allow-listed public runtime value in SSR and in the browser. */
export function getEnvVar(key: string): string {
  if (typeof window === "undefined") {
    if (key === "VITE_STOCKHOLM_PROFILE_CANONICALS") {
      // The SSR server, integrity gate, sitemap and injected browser value all
      // use this single server-owned flag. Reading a Vite build-time value
      // here could make SSR markup disagree with hydration.
      return process.env.STOCKHOLM_PROFILE_CANONICALS || "";
    }
    return process.env[key] || "";
  }
  const runtimeEnvironment = window.__VITE_ENV__;
  if (
    runtimeEnvironment &&
    Object.prototype.hasOwnProperty.call(runtimeEnvironment, key)
  ) {
    return runtimeEnvironment[key] || "";
  }
  return import.meta.env[key] || "";
}

export function getGraphqlUrl(): string {
  return getEnvVar("VITE_GRAPHQL_URL");
}

export function getGraphqlWsUrl(): string {
  return getEnvVar("VITE_GRAPHQL_WS_URL");
}

export function localProviderCanonicalsEnabled(): boolean {
  return getEnvVar("VITE_STOCKHOLM_PROFILE_CANONICALS") === "1";
}

/**
 * Canonical URL for a Stockholm provider profile. Until the profile-migration
 * flag flips, profiles canonicalize off-site to Hemtjänstguide, so structured
 * data (ItemList, breadcrumbs) must advertise that URL — not the on-site one —
 * to stay aligned with `<link rel="canonical">` and the sitemap gate.
 */
export function stockholmProviderCanonicalUrl(slug: string): string {
  const encoded = encodeURIComponent(slug);
  return localProviderCanonicalsEnabled()
    ? `https://hemtjanstistockholm.se/utforare/${encoded}`
    : `https://hemtjanstguide.se/anordnare/${encoded}?kommun=stockholm`;
}
